
import React from 'react';
import { Bot, Sparkles } from 'lucide-react';
import { PropertyField } from '../../molecules/PropertyField';
import { WorkflowNodeData } from '../../../types';

interface LLMConfigTabProps {
    data: WorkflowNodeData;
    onChange: (key: string, value: any) => void;
}

export const LLMConfigTab: React.FC<LLMConfigTabProps> = ({ data, onChange }) => {
    return (
        <div className="p-6 space-y-6">
             <div className="p-3 bg-purple-50 dark:bg-purple-900/20 rounded-lg border border-purple-100 dark:border-purple-900 flex gap-3">
                <Bot className="text-purple-600 dark:text-purple-400 mt-0.5 shrink-0" size={16} />
                <div className="space-y-1">
                    <p className="text-xs font-bold text-purple-800 dark:text-purple-300">LLM Configuration</p>
                    <p className="text-[11px] text-purple-700 dark:text-purple-400 leading-relaxed">
                        Configure the AI model parameters and system instructions.
                    </p>
                </div>
            </div>

            <div className="space-y-4">
                <PropertyField
                    config={{ 
                        name: 'model', 
                        label: 'Model', 
                        type: 'select', 
                        options: [
                            {value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash'}, 
                            {value: 'gemini-3-pro-preview', label: 'Gemini 3.0 Pro'}
                        ],
                        defaultValue: 'gemini-2.5-flash'
                    }}
                    value={data.model}
                    onChange={onChange}
                />
                
                <PropertyField
                    config={{ 
                        name: 'systemPrompt', 
                        label: 'System Prompt', 
                        type: 'textarea', 
                        rows: 8, 
                        placeholder: 'You are a helpful assistant...',
                        description: 'Define the persona and behavioral constraints.'
                    }}
                    value={data.systemPrompt}
                    onChange={onChange}
                />

                <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-900 flex items-start gap-2">
                    <Sparkles className="text-blue-500 mt-0.5" size={14} />
                    <p className="text-xs text-blue-700 dark:text-blue-300">
                        This node uses the Gemini API. Ensure <code>API_KEY</code> is set in the environment.
                    </p>
                </div>
            </div>
        </div>
    );
};
